import { debounce } from "@/utils"
import React from "react"

export function useDebounce(callback, delay) {
    const callbackRef = React.useRef(callback)
    React.useLayoutEffect(() => {
        callbackRef.current = callback
    })
    return React.useMemo(() => debounce((...args) => callbackRef.current(...args), delay), [delay])
}
